import { Routes, Route } from "react-router-dom";
import QuayAvailabilities from "./QuayAvailabilities";

const index = () => {
	return (
		<Routes>
			<Route index element={<QuayAvailabilities />} />
		</Routes>
	);
};

export default index;
